import { env } from "../../../env";
const axios = require("axios").default;

const URL_ORI = `${env.REACT_APP_API_URL}`;

export const getClient = (payload) => {
  return axios
    .get(`${URL_ORI}/api/Client/search`, {
      params: payload,
    })
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};
export const getClientMaster = (payload) => {
  return axios
    .get(`${URL_ORI}/api/Client/searchmaster`, {
      params: payload,
    })
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const createClient = (payload) => {
  return axios.post(`${URL_ORI}/api/Client`, payload).catch((error) => {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      console.log(error.request);
    } else {
      console.log(error.message);
    }
  });
};

export const getIdClient = (id) => {
  return axios
    .get(`${URL_ORI}/api/Client/${id}`, {
      params: id,
    })
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const updateClient = (payload) => {
  return axios.put(`${URL_ORI}/api/Client`, payload).catch((error) => {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      console.log(error.request);
    } else {
      console.log(error.message);
    }
  });
};

export const deleteClient = (payload) => {
  return axios.delete(`${URL_ORI}/api/Client`, payload).catch((error) => {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      console.log(error.request);
    } else {
      console.log(error.message);
    }
  });
};

export const createOfficeMapping= (payload) => {
  return axios.post(`${URL_ORI}/api/Client/addoffice`, payload).catch((error) => {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      console.log(error.request);
    } else {
      console.log(error.message);
    }
  });
};

export const deleteOfficeMaping= (payload) => {
  return axios.delete(`${URL_ORI}/api/Client/deleteOffices`, payload).catch((error) => {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      console.log(error.request);
    } else {
      console.log(error.message);
    }
  });
};


